<route>{ "meta": { "moduleCode": "VEHICLE_WORK_ORDER" } }</route>
<template>
    <PageHeader :title="(form.updateStatus) ? sprintf($t('pages.module.VEHICLE_WORK_ORDER.editItemPattern'), [data.vehicle_snapshot.formatted_plate_number]) : $t('pages.module.VEHICLE_WORK_ORDER.newItem')" back-to="/module/vehicle-work-order/list"/>

    <el-form :model="form.data" ref="dataForm">
        <div class="row g-6 mb-6 g-xl-9 mb-xl-9 unset-position-card">
            <div class="col-md-9">
                <div class="card mb-5" v-if="!form.updateStatus && !(searchVehicle.length > 0 && form.data.customer_vehicle_id && form.data.company_customer_id)">
                    <div class="card-header border-bottom-dashed">
                        <h4 class="card-title">
                            {{ $t('pages.module.VEHICLE_WORK_ORDER.save.fastSearch.title') }}
                        </h4>
                    </div>
                    <div class="card-body px-9 pt-4">
                        <div class="row">
                            <div class="col-9">
                                <div class="fv-row mb-1 mt-3">
                                    <el-form-item>
                                        <el-input v-model="searchVehicle" type="text" :placeholder="$t('pages.module.VEHICLE_WORK_ORDER.save.fastSearch.placeholder')"/>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="h-100 d-flex align-items-end pb-6">
                                    <el-button class="btn btn-primary lh-0 w-100" @click="resetSearch">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.fastSearch.resetButton') }}</el-button>
                                </div>
                            </div>

                            <div class="col-12" v-if="searchVehicle.trim().length > 0 && customerVehicle && customerVehicle.length > 0">
                                <div class="card border border-dashed">
                                    <div class="card-header">
                                        <div class="mt-3">
                                            <h4 class="card-title">
                                                {{ $t('pages.module.VEHICLE_WORK_ORDER.save.fastSearch.registeredVehicle') }}
                                            </h4>
                                            <p class="text-muted">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.fastSearch.registeredVehicleDescription') }}</p>
                                        </div>
                                    </div>
                                    <div class="card-body customer-list">
                                        <div class="row g-3">
                                            <div class="col-md-6" v-for="(vehicle, vehicleIndex) in customerVehicle" :key="vehicleIndex">
                                                <div class="customer-card" :class="{ active: form.data.customer_vehicle_id === vehicle.id }" @click="setCustomerVehicle(vehicle)">
                                                    <div class="d-flex align-items-center">
                                                        <div class="flex-grow-1">
                                                            <div class="fw-bold">
                                                                {{ vehicle.formatted_plate_number }}
                                                            </div>
                                                            <div class="fw-bold text-gray-800">
                                                                {{ vehicle.company_customer.full_name }}
                                                            </div>
                                                            <div class="text-muted fs-7">
                                                                {{ vehicle.company_customer.mobile_phone }}
                                                            </div>
                                                        </div>

                                                        <div v-if="form.data.customer_vehicle_id === vehicle.id">
                                                            <i class="bi bi-check-circle-fill text-primary fs-4"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mb-5">
                    <div class="card-header border-bottom-dashed">
                        <h4 class="card-title">
                            {{ $t('pages.module.VEHICLE_WORK_ORDER.save.customer.title') }}
                        </h4>
                    </div>
                    <div class="card-body px-9 pt-4">
                        <div class="row">
                            <div class="col-md-6 col-lg-4">
                                <div class="fv-row mb-1 mt-3">
                                    <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.customer.cols.firstname') }}</label>
                                    <el-form-item prop="company_customer.firstname" :rules="$validation.getMessage(['required'])">
                                        <el-input v-model="form.data.company_customer.firstname" type="text" :disabled="form.data.company_customer_id"/>
                                    </el-form-item>
                                </div>
                            </div>

                            <div class="col-md-6 col-lg-4">
                                <div class="fv-row mb-1 mt-3">
                                    <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.customer.cols.lastname') }}</label>
                                    <el-form-item prop="company_customer.lastname" :rules="$validation.getMessage(['required'])">
                                        <el-input v-model="form.data.company_customer.lastname" type="text" :disabled="form.data.company_customer_id"/>
                                    </el-form-item>
                                </div>
                            </div>

                            <div class="col-md-6 col-lg-4">
                                <div class="fv-row mb-1 mt-3">
                                    <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.customer.cols.mobilePhone') }}</label>
                                    <el-form-item prop="company_customer.mobile_phone" :rules="$validation.getMessage(['required'])">
                                        <MobilePhoneInput v-model:data="form.data.company_customer.mobile_phone" @mobile-phone-number="handleMobilePhoneNumber" :disabled="form.data.company_customer_id"/>
                                    </el-form-item>
                                </div>
                            </div>

                            <div class="col-12" v-if="!form.updateStatus && (customers && customers.length > 0) && (form.data.company_customer.firstname.length > 0 || form.data.company_customer.lastname.length > 0 || form.data.company_customer.mobile_phone.length > 0)">
                                <div class="card border border-dashed">
                                    <div class="card-header">
                                        <div class="d-flex align-items-center justify-content-between gap-3 w-100 mt-3">
                                            <div>
                                                <h4 class="card-title">
                                                    {{ $t('pages.module.VEHICLE_WORK_ORDER.save.customer.registeredUser') }}
                                                </h4>
                                                <p class="text-muted">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.customer.registeredUserDescription') }}</p>
                                            </div>
                                            <div class="h-100 d-flex align-items-end pb-6">
                                                <el-button class="btn btn-primary lh-0 w-100" @click="resetSearch">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.fastSearch.resetButton') }}</el-button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body customer-list">
                                        <div class="row g-3">
                                            <div class="col-12" v-for="(customer, customerIndex) in customers" :key="customerIndex">
                                                <div class="customer-card" :class="{ active: form.data.company_customer_id === customer.id }" @click="setCustomer(customer)">
                                                    <div class="d-flex align-items-center">
                                                        <div class="symbol symbol-40px symbol-circle bg-light-primary me-4">
                                                            <span class="symbol-label fw-bold text-primary">
                                                                {{ customer.full_name.charAt(0) }}
                                                            </span>
                                                        </div>

                                                        <div class="flex-grow-1">
                                                            <div class="fw-bold text-gray-800">
                                                                {{ customer.full_name }}
                                                            </div>
                                                            <div class="text-muted fs-7">
                                                                {{ customer.mobile_phone }}
                                                            </div>
                                                        </div>

                                                        <div v-if="form.data.company_customer_id === customer.id">
                                                            <i class="bi bi-check-circle-fill text-primary fs-4"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mb-5">
                    <div class="card-header border-bottom-dashed">
                        <h4 class="card-title">
                            {{ $t('pages.module.VEHICLE_WORK_ORDER.save.vehicle.title') }}
                        </h4>
                    </div>
                    <div class="card-body px-9 pt-4">
                        <div class="card bg-light border border-dashed" v-if="form.updateStatus">
                            <div class="card-body p-0 py-8">
                                <div class="row">
                                    <div class="col-xl-4 col-sm-12 pb-5">
                                        <div class="d-flex flex-column justify-content-center h-100 border-end border-end-lg">
                                            <div class="d-flex align-items-center justify-content-center position-relative">
                                                <img src="/media/car/car_back.png" class="car-image" alt="car">
                                                <div class="position-absolute bottom-0">
                                                    <Plate country-code="tr" :number="data.vehicle_snapshot.formatted_plate_number"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-xl-8 col-sm-12 px-10">
                                        <div class="d-flex flex-column justify-content-center h-100">
                                            <div class="d-flex justify-content-between mb-2">
                                                <span class="text-muted">{{ $t('pages.customer.detail.vehicle.brand') }}:</span>
                                                <span class="fw-semibold">{{ data.vehicle_snapshot.brand.name }}</span>
                                            </div>

                                            <div class="d-flex justify-content-between mb-2">
                                                <span class="text-muted">{{ $t('pages.customer.detail.vehicle.model') }}:</span>
                                                <span class="fw-semibold text-end">{{ data.vehicle_snapshot.brand_model.name }}</span>
                                            </div>

                                            <div class="d-flex justify-content-between mb-2">
                                                <span class="text-muted">{{ $t('pages.customer.detail.vehicle.year') }}:</span>
                                                <span class="fw-semibold">{{ data.vehicle_snapshot.year.year }}</span>
                                            </div>

                                            <div class="card fv-row mt-3 p-3 border border-dashed">
                                                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.vehicle.cols.odometer') }}</label>
                                                <el-form-item prop="odometer" :rules="$validation.getMessage(['required'])">
                                                    <el-input v-model="form.data.odometer" type="number"/>
                                                </el-form-item>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <el-tabs v-model="tabVehicleModel" v-else>
                            <el-tab-pane :label="$t('pages.module.VEHICLE_WORK_ORDER.save.vehicle.newCar')" name="newVehicle">
                                <div class="card bg-light border border-dashed">
                                    <div class="card-body p-0 py-8">
                                        <div class="row">
                                            <div class="col-xl-4 col-sm-12 pb-5">
                                                <div class="d-flex flex-column justify-content-center h-100 border-end border-end-lg">
                                                    <div class="d-flex align-items-center justify-content-center position-relative">
                                                        <img src="/media/car/car_back.png" class="car-image" alt="car">
                                                        <div class="position-absolute bottom-0" v-if="form.data.company_customer.vehicle.plate.length > 0">
                                                            <Plate country-code="tr" v-model:number="form.data.company_customer.vehicle.plate"/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-xl-8 col-sm-12 px-10">
                                                <div class="row h-100">
                                                    <div class="col-md-6 col-lg-6">
                                                        <div class="fv-row mb-1 mt-3">
                                                            <label class="fs-6 fw-bold mb-2">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.vehicle.cols.brand_model') }}</label>
                                                            <el-form-item prop="company_customer.vehicle.model_id" :rules="$validation.getMessage(['required'])">
                                                                <el-select v-model="form.data.company_customer.vehicle.model_id" class="w-100" :placeholder="$t('common.search')" filterable remote reserve-keyword :remote-method="getSearchBrandModel" :loading="modelLoading">
                                                                    <el-option v-for="item in searchModels" :key="item.id" :value="item.id" :label="item.brand_name + ' - ' + item.name"/>
                                                                </el-select>
                                                            </el-form-item>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6 col-lg-6">
                                                        <div class="fv-row mb-1 mt-3">
                                                            <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.vehicle.cols.year') }}</label>
                                                            <el-form-item prop="company_customer.vehicle.year_id" :rules="$validation.getMessage(['required'])" v-if="!form.data.customer_vehicle_id">
                                                                <el-select v-model="form.data.company_customer.vehicle.year_id" class="w-100" :placeholder="$t('common.chooseSelect')" filterable>
                                                                    <el-option v-for="(item, itemIndex) in years" :key="itemIndex" :value="item.id" :label="item.year"></el-option>
                                                                </el-select>
                                                            </el-form-item>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6 col-lg-6">
                                                        <div class="fv-row mb-1 mt-3">
                                                            <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.vehicle.cols.plate') }}</label>
                                                            <el-form-item prop="company_customer.vehicle.plate" :rules="$validation.getMessage(['required'])" v-if="!form.data.customer_vehicle_id">
                                                                <el-input v-model="form.data.company_customer.vehicle.plate" type="text"/>
                                                            </el-form-item>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6 col-lg-6">
                                                        <div class="fv-row mb-1 mt-3">
                                                            <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.vehicle.cols.odometer') }}</label>
                                                            <el-form-item prop="odometer" :rules="$validation.getMessage(['required'])">
                                                                <el-input v-model="form.data.odometer" type="number"/>
                                                            </el-form-item>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane :label="$t('pages.module.VEHICLE_WORK_ORDER.save.vehicle.registeredVehicle')" name="registeredVehicle" v-if="form.data.company_customer_id && customerVehicle.length > 0">
                                <div class="row g-3">
                                    <div class="col-md-6" v-for="(vehicle, vehicleIndex) in customerVehicle" :key="vehicleIndex">
                                        <div class="customer-card position-relative border border-dashed" :class="{ 'active border-primary': form.data.customer_vehicle_id === vehicle.id }" @click="setCustomerVehicle(vehicle)">
                                            <div class="card-body p-2">
                                                <div class="row">
                                                    <div class="col-4">
                                                        <div class="d-flex flex-column justify-content-center h-100">
                                                            <div class="d-flex align-items-center justify-content-center position-relative">
                                                                <img src="/media/car/car_back.png" class="car-image" alt="car">
                                                                <div class="position-absolute bottom-0">
                                                                    <Plate country-code="tr" :number="vehicle.formatted_plate_number"/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-8">
                                                        <div class="d-flex flex-column justify-content-center h-100">
                                                            <div class="d-flex justify-content-end mb-2">
                                                                <el-button size="small" @click="showVehicleHistory(vehicle)">
                                                                    <span class="svg-icon svg-icon-5 me-2">
                                                                        <inline-svg src="/media/icons/duotune/art/art005.svg"/>
                                                                    </span>
                                                                    {{ $t('pages.module.VEHICLE_WORK_ORDER.save.vehicle.historyVehicleWorkOrder.btn') }}
                                                                </el-button>
                                                            </div>

                                                            <div class="d-flex justify-content-end mb-2">
                                                                <span class="fw-bold">{{ vehicle.brand.name }}</span>
                                                            </div>

                                                            <div class="d-flex justify-content-end mb-2">
                                                                <span class="fw-semibold text-end">{{ vehicle.brand_model.name }}</span>
                                                            </div>

                                                            <div class="d-flex justify-content-end">
                                                                <span class="fw-">{{ vehicle.year.year }}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card bg-light border border-dashed p-5 mt-4">
                                    <div class="fv-row">
                                        <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.vehicle.cols.odometer') }}</label>
                                        <el-form-item prop="odometer" :rules="$validation.getMessage(['required'])">
                                            <el-input v-model="form.data.odometer" type="number"/>
                                        </el-form-item>
                                    </div>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                </div>

                <div class="card mb-5">
                    <div class="card-header border-bottom-dashed">
                        <h4 class="card-title">
                            {{ $t('pages.module.VEHICLE_WORK_ORDER.save.items.subTitle') }}
                        </h4>
                    </div>
                    <div class="card-body px-9 pt-4">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="fv-row mb-1 mt-3">
                                    <label class="fs-6 fw-bold mb-2">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.cols.complaint') }}</label>
                                    <el-form-item>
                                        <el-input v-model="form.data.complaint" type="textarea" rows="10"/>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="fv-row mb-1 mt-3">
                                    <label class="fs-6 fw-bold mb-2">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.cols.diagnosis') }}</label>
                                    <el-form-item>
                                        <el-input v-model="form.data.diagnosis" type="textarea" rows="10"/>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>

                        <div class="card bg-light p-4 mt-9">
                            <div class="card-header">
                                <h4 class="card-title">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.items.subTitle') }}</h4>
                            </div>
                            <div class="card-body">
                                <div v-for="(item, itemIndex) in form.data.items" class="vwo-item" :key="itemIndex">
                                    <div class="vwo-item-title">
                                        <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.items.cols.title') }}</label>
                                        <div class="position-relative vwo-stock-input">
                                            <el-form-item :prop="'items[' + itemIndex + '].title'" :rules="$validation.getMessage(['required'])" class="mb-0">
                                                <el-input
                                                    v-model="item._stockSearchQuery"
                                                    type="text"
                                                    :readonly="!!item._selectedStock"
                                                    :placeholder="$t('pages.module.VEHICLE_WORK_ORDER.save.items.cols.stockSearchPlaceholder')"
                                                    :class="{'vwo-stock-selected': item._selectedStock}"
                                                    @input="onItemTitleInput($event, itemIndex)"
                                                    @keydown="onItemTitleKeydown($event, itemIndex)"
                                                    @focus="!item._selectedStock && item._stockSearchQuery && item._stockSearchQuery.length >= 2 ? debouncedStockSearch(item._stockSearchQuery, itemIndex) : null"
                                                >
                                                    <template #suffix>
                                                        <span v-if="item._selectedStock" class="vwo-stock-clear" @click.stop="clearStockSelection(itemIndex); item.title = ''; item._stockSearchQuery = '';">
                                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                                                        </span>
                                                    </template>
                                                </el-input>
                                            </el-form-item>
                                            <div v-if="activeStockSearchIndex === itemIndex" class="vwo-stock-dropdown">
                                                <div v-if="stockSearchLoading" class="vwo-stock-dropdown-loading">
                                                    <div class="vwo-loading-spinner"></div>
                                                </div>
                                                <template v-else-if="stockSearchResults.length > 0">
                                                    <div v-for="stock in stockSearchResults" :key="stock.id" class="vwo-stock-dropdown-item" @click="selectStock(stock, itemIndex)">
                                                        <div class="vwo-stock-dropdown-text">
                                                            <span class="vwo-stock-dropdown-name">{{ stock.name }}</span>
                                                            <span v-if="stock.code" class="vwo-stock-dropdown-code">{{ stock.code }}</span>
                                                        </div>
                                                        <span v-if="stock.sale_price" class="vwo-stock-dropdown-price">{{ format(stock.sale_price) }} ₺</span>
                                                    </div>
                                                </template>
                                                <div v-else class="vwo-stock-dropdown-empty">
                                                    {{ $t('pages.module.VEHICLE_WORK_ORDER.save.items.cols.stockSearch.noResults') }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="vwo-item-fields">
                                        <div class="vwo-field vwo-field--unit">
                                            <label class="fs-6 fw-bold mb-2">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.items.cols.unit') }}</label>
                                            <el-form-item class="mb-0">
                                                <el-select v-model="item.unit_id" :placeholder="$t('common.chooseSelectShort')" :disabled="!!item._selectedStock">
                                                    <el-option v-for="unit in $root.unitTypes" :key="unit.id" :value="unit.id" :label="unit.name"/>
                                                </el-select>
                                            </el-form-item>
                                        </div>
                                        <div class="vwo-field vwo-field--qty">
                                            <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.items.cols.quantity') }}</label>
                                            <el-form-item :prop="'items[' + itemIndex + '].quantity'" :rules="$validation.getMessage(['required'])" class="mb-0">
                                                <el-input-number v-model="item.quantity" :min="1" @change="calculateTotalPrice"/>
                                            </el-form-item>
                                        </div>
                                        <div class="vwo-field vwo-field--price" v-if="form.data.price_type_id === 1">
                                            <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.items.cols.price') }}</label>
                                            <el-form-item :prop="'items[' + itemIndex + '].price'" :rules="$validation.getMessage(['required'])" class="mb-0">
                                                <el-input v-model="item.price" type="number" @input="calculateTotalPrice"/>
                                            </el-form-item>
                                        </div>
                                        <div class="vwo-field vwo-field--action">
                                            <el-popconfirm width="380" :title="$t('messages.sureDelete')" :confirm-button-text="$t('btn.yes')" :cancel-button-text="$t('btn.no')" @confirm="removeItem(itemIndex, item.id)">
                                                <template #reference>
                                                    <button type="button" class="btn btn-icon btn-sm border vwo-delete-btn">
                                                        <span class="svg-icon svg-icon-3">
                                                            <inline-svg src="/media/icons/duotune/general/gen027.svg"/>
                                                        </span>
                                                        <span class="vwo-delete-label">{{ $t('btn.remove') }}</span>
                                                    </button>
                                                </template>
                                            </el-popconfirm>
                                        </div>
                                    </div>
                                </div>

                                <div class="d-flex align-items-center justify-content-center flex-column w-100">
                                    <div class="alert alert-dismissible bg-primary d-flex flex-column flex-sm-row p-5 mb-10 w-100" v-if="!form.data.items.length">
                                        <i class="bi bi-ui-checks fs-2hx text-light me-4 mb-5 mb-sm-0"></i>

                                        <div class="d-flex flex-column text-light pe-0 pe-sm-10">
                                            <h4 class="mb-2 light">{{ $t('pages.module.VEHICLE_WORK_ORDER.item.emptyItemAlert.title') }}</h4>
                                            <span>{{ $t('pages.module.VEHICLE_WORK_ORDER.item.emptyItemAlert.message') }}</span>
                                        </div>
                                    </div>

                                    <div>
                                        <button class="btn btn-primary" type="button" @click="addNewItem()">{{ $t('pages.module.VEHICLE_WORK_ORDER.item.newItem') }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-3">
                <div class="sticky-card">
                    <div class="card">
                        <div class="card-body">
                            <div class="fv-row mb-8 mt-3">
                                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.cols.type') }}</label>
                                <el-form-item prop="type_id" :rules="$validation.getMessage(['required'])">
                                    <el-select v-model="form.data.type_id" class="w-100" :placeholder="$t('common.chooseSelect')" filterable>
                                        <el-option v-for="(item, itemIndex) in types" :key="itemIndex" :value="item.id" :label="item.name"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <div class="fv-row mb-4 mt-3">
                                <label class="fs-6 fw-bold mb-2">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.cols.statusId') }}</label>
                                <el-form-item>
                                    <el-select v-model="form.data.status_id" class="w-100" :placeholder="$t('common.chooseSelect')" filterable>
                                        <el-option v-for="(item, itemIndex) in status" :key="itemIndex" :value="item" :label="$t('pages.module.VEHICLE_WORK_ORDER.cols.status.' + item)"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>
                    </div>

                    <div class="card mt-5">
                        <div class="card-body">
                            <div class="fv-row mb-8 mt-3">
                                <label class="required fs-6 fw-bold mb-2">
                                    {{ $t('pages.module.VEHICLE_WORK_ORDER.save.cols.priceTypeId') }}
                                </label>
                                <el-popover
                                    :title="$t('pages.module.VEHICLE_WORK_ORDER.save.cols.priceTypeId')"
                                    :content="$t('pages.module.VEHICLE_WORK_ORDER.save.cols.priceTypeIdSubTitle')"
                                    placement="top"
                                    width="380">
                                    <template #reference>
                                        <i class="fa fa-info-circle"></i>
                                    </template>
                                </el-popover>
                                <el-form-item :prop="'price_type_id'" :rules="$validation.getMessage(['required'])">
                                    <el-radio-group v-model="form.data.price_type_id" text-color="#fff" fill="#0C2C55">
                                        <el-radio-button :label="$t('pages.module.VEHICLE_WORK_ORDER.save.cols.priceType.itemBased')" :value="1"/>
                                        <el-radio-button :label="$t('pages.module.VEHICLE_WORK_ORDER.save.cols.priceType.orderBased')" :value="2"/>
                                    </el-radio-group>
                                </el-form-item>
                            </div>
                            <div class="fv-row mb-1 mt-3" :class="form.data.price_type_id === 1 ? 'd-flex align-items-center justify-content-between gap-3' : ''">
                                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.cols.totalPrice') }}</label>
                                <el-form-item v-if="form.data.price_type_id === 2" :prop="'total_price'" :rules="$validation.getMessage(['required'])">
                                    <el-input v-model="form.data.total_price" oninput="value=value.replace(/[^0-9.]/g,'')"/>
                                </el-form-item>
                                <span class="fs-5 fw-bold" v-if="form.data.price_type_id === 1">{{ form.data.total_price }} ₺</span>
                            </div>
                            <div v-if="!form.updateStatus" class="vwo-initial-payment mt-4">
                                <div class="vwo-initial-payment-head">
                                    <span class="vwo-initial-payment-title">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.payment.initialTitle') }}</span>
                                    <span class="vwo-initial-payment-pill">{{ $t('common.optional') }}</span>
                                </div>
                                <div class="vwo-initial-payment-grid">
                                    <div class="vwo-initial-payment-field">
                                        <label class="vwo-initial-payment-label">{{ $t('common.transaction.payment.amount') }}</label>
                                        <el-input v-model="form.data.total_paid"
                                            oninput="value=value.replace(/[^0-9.]/g,'')"
                                            :placeholder="$t('common.transaction.payment.amountPlaceholder')"/>
                                    </div>
                                    <div class="vwo-initial-payment-field">
                                        <label class="vwo-initial-payment-label" :class="{ 'vwo-initial-payment-label--required': hasInitialPaymentAmount }">{{ $t('common.transaction.payment.method') }}</label>
                                        <el-select v-model="form.data.payment_method_id"
                                            class="w-100"
                                            :placeholder="$t('common.transaction.payment.methodPlaceholder')"
                                            :disabled="!hasInitialPaymentAmount">
                                            <el-option v-for="m in paymentMethods" :key="m.id" :label="paymentMethodLabel(m)" :value="m.id"/>
                                        </el-select>
                                    </div>
                                </div>
                                <span class="vwo-initial-payment-hint">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.payment.initialHint') }}</span>
                            </div>

                            <div v-else-if="form.data.transaction" class="vwo-payment-summary mt-4">
                                <div class="vwo-payment-summary-head">
                                    <span class="vwo-payment-summary-title">
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                                            <rect x="2" y="6" width="20" height="13" rx="2"/>
                                            <line x1="2" y1="11" x2="22" y2="11"/>
                                            <line x1="6" y1="15" x2="9" y2="15"/>
                                        </svg>
                                        {{ $t('common.transaction.payment.title') }}
                                    </span>
                                    <span class="vwo-status-pill" :class="'vwo-status-pill--' + form.data.transaction.status_id">
                                        {{ $t('common.transaction.status.' + form.data.transaction.status_id) }}
                                    </span>
                                </div>
                                <div class="vwo-payment-summary-list">
                                    <div class="vwo-payment-summary-row">
                                        <span class="label">{{ $t('common.transaction.summary.total') }}</span>
                                        <span class="value">{{ formatTRY(form.data.transaction.total_amount) }}</span>
                                    </div>
                                    <div class="vwo-payment-summary-row">
                                        <span class="label">{{ $t('common.transaction.summary.paid') }}</span>
                                        <span class="value value--paid">{{ formatTRY(form.data.transaction.paid_amount) }}</span>
                                    </div>
                                    <div class="vwo-payment-summary-row">
                                        <span class="label">{{ $t('common.transaction.summary.remaining') }}</span>
                                        <span class="value value--remaining">{{ formatTRY(form.data.transaction.remaining_amount) }}</span>
                                    </div>
                                </div>
                                <button type="button" class="vwo-payment-manage-btn" @click="openPaymentPanel">
                                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <rect x="2" y="6" width="20" height="13" rx="2"/>
                                        <line x1="2" y1="11" x2="22" y2="11"/>
                                    </svg>
                                    {{ $t('common.transaction.actions.detailedManage') }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div v-if="form.updateStatus" class="card mt-5 vwo-gallery-card">
                        <div class="vwo-gallery-header">
                            <div class="vwo-gallery-title">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
                                <span>{{ $t('pages.module.VEHICLE_WORK_ORDER.save.images.title') }}</span>
                                <span v-if="vwoImageCount > 0" class="vwo-gallery-count">{{ vwoImageCount }}</span>
                            </div>
                            <button type="button" class="vwo-gallery-manage" @click="openImagePicker">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.images.manage') }}</button>
                        </div>
                        <div v-if="vwoImages.length" class="vwo-gallery-grid">
                            <div v-for="(img, i) in vwoImages" :key="img.id || i" class="vwo-gallery-item" @click="openImagePicker">
                                <img :src="img.thumbnailUrl || img.publicUrl" :alt="img.name"/>
                                <button type="button" class="vwo-gallery-remove" @click.stop="removeVwoImage(i)">
                                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                                </button>
                            </div>
                        </div>
                        <div v-else class="vwo-gallery-empty" @click="openImagePicker">
                            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
                            <span>{{ $t('pages.module.VEHICLE_WORK_ORDER.save.images.empty') }}</span>
                        </div>
                    </div>

                    <div class="fv-row mt-5">
                        <el-form-item class="mb-0">
                            <button @click.prevent="onSubmit" :data-kt-indicator="form.loading ? 'on' : null" class="btn btn-lg btn-primary w-100" type="button">
                                <span v-if="!form.loading" class="indicator-label">{{ $t("btn.save") }}</span>
                                <span v-if="form.loading" class="indicator-progress">
                                    {{ $t("messages.wait") }}
                                    <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                            </button>
                        </el-form-item>
                    </div>
                </div>
            </div>
        </div>
    </el-form>


    <div class="modal fade" id="kt_modal_vehicle_work_order_list" ref="vehicleWorkOrderListModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xxl">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="fw-bolder">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.vehicle.historyVehicleWorkOrder.title') }}</h2>
                    <div id="kt_modal_add_customer_close" data-bs-dismiss="modal" class="btn btn-icon btn-sm btn-active-icon-primary">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="/media/icons/duotune/arrows/arr061.svg"/>
                        </span>
                    </div>
                </div>
                <div class="modal-body p-0 m-0">
                    <custom-table
                        hide-header="true"
                        rowKey="id"
                        :items="vehicleWorkOrder.data"
                        :loading="vehicleWorkOrder.loading"
                        :columns="vehicleWorkOrderFields"
                        :pagination="vehicleWorkOrder.pagination"
                    >
                        <template v-slot:user="{ row: record }">
                            <span class="fw-bolder">{{ record.company_customer.firstname + ' ' + record.company_customer.lastname }}</span><br>
                            <span class="fw-bolder fs-7">{{ record.company_customer.customer.mobile_phone ? formatPhonePretty(record.company_customer.customer.mobile_phone) : "-" }}</span>
                        </template>
                        <template v-slot:plate="{ row: record }">
                            <Plate country-code="tr" :number="record.vehicle_snapshot?.formatted_plate_number"/>
                        </template>
                        <template v-slot:car="{ row: record }">
                            <span class="fw-bolder">{{ record.vehicle_snapshot?.brand?.name }}</span> <span class="fw-light fs-6">({{ record.vehicle_snapshot?.year?.year }})</span><br>
                            <span class="fw-light fs-6">{{ record.vehicle_snapshot?.brand_model?.name }}</span><br>
                        </template>
                        <template v-slot:statusId="{ row: record }">
                            <span :class="getStatusColor(record.status_id)" class="badge">{{ $t('pages.module.VEHICLE_WORK_ORDER.cols.status.' + record.status_id) }}</span>
                        </template>
                        <template v-slot:typeName="{ row: record }">
                            {{ record.type.name }}
                        </template>
                        <template v-slot:price="{ row: record }">
                            {{ record.total_price }} /
                            <span :class="{ 'text-success': record.total_price === record.total_paid, 'text-danger': record.total_price !== record.total_paid }">{{ record.total_paid }}</span>
                        </template>
                        <template v-slot:created_at="{ row: record }">
                            {{ $moment(record.created_at).format("DD.MM.YYYY - HH:mm:ss") }}
                        </template>
                        <template v-slot:actions="{ row: record }">
                            <el-tooltip :content="$t('common.detail')" placement="top">
                                <button class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1" @click="showWorkOrderHistory(record.id)">
                                    <span class="svg-icon svg-icon-3">
                                           <inline-svg src="/media/icons/duotune/general/gen004.svg"/>
                                    </span>
                                </button>
                            </el-tooltip>
                        </template>
                    </custom-table>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="kt_modal_vehicle_work_order_show" ref="vehicleWorkOrderShowModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="fw-bolder">{{ sprintf($t('pages.module.VEHICLE_WORK_ORDER.detailTitle'), ['#' + vehicleWorkOrderShow?.id ?? '']) }}</h2>
                    <div id="kt_modal_add_customer_close" data-bs-dismiss="modal" class="btn btn-icon btn-sm btn-active-icon-primary">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="/media/icons/duotune/arrows/arr061.svg"/>
                        </span>
                    </div>
                </div>
                <div class="modal-body p-0 m-0">
                    <div class="row px-10 py-5">
                        <div class="col-md-6">
                            <div class="fv-row mb-1 mt-3">
                                <label class="fs-6 fw-bold mb-2">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.cols.complaint') }}:</label>
                                <el-alert
                                    :title="$t('pages.module.VEHICLE_WORK_ORDER.alert.not_found_complaint')"
                                    type="warning"
                                    show-icon
                                    :closable="false"
                                    v-if="!vehicleWorkOrderShow?.complaint?.length"
                                />
                                <div class="modalText" v-else>
                                    {{ vehicleWorkOrderShow?.complaint ?? "-" }}
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="fv-row mb-1 mt-3">
                                <label class="fs-6 fw-bold mb-2">{{ $t('pages.module.VEHICLE_WORK_ORDER.save.cols.diagnosis') }}:</label>
                                <el-alert
                                    :title="$t('pages.module.VEHICLE_WORK_ORDER.alert.not_found_diagnosis')"
                                    type="warning"
                                    show-icon
                                    :closable="false"
                                    v-if="!vehicleWorkOrderShow?.diagnosis?.length"
                                />
                                <div class="modalText" v-else>
                                    {{ vehicleWorkOrderShow?.diagnosis ?? "-" }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <custom-table
                        hide-header="true"
                        rowKey="id"
                        :items="vehicleWorkOrderShow?.items ?? []"
                        :columns="vehicleWorkOrderItemFields"
                        :record="vehicleWorkOrderShow"
                    >
                    </custom-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from "@/components/page-header/PageHeader.vue";
import Plate from "@/components/plate/Plate.vue";
import CustomTable from "@/components/custom-table/index.vue";
import MobilePhoneInput from "@/components/custom-mobile-phone-selector/";
import {formatPhonePretty, getModuleIdByCode} from "@/core/services/Helper";
import fileManagerPicker from "@/components/filemanager/fileManagerPicker";
import transactionService from "@/components/payment/transactionService";

export default {
    name: "_id",
    components: {
        CustomTable,
        Plate,
        PageHeader,
        MobilePhoneInput
    },
    data() {
        return {
            loadingModels: false,
            isInitializing: true,
            isFetchingCustomer: false,
            tabVehicleModel: 'newVehicle',
            searchVehicle: '',
            data: {},
            form: {
                title: '',
                loading: false,
                updateStatus: false,
                data: {}
            },
            vehicleWorkOrderItems: {},
            rules: {},
            stockSearchResults: [],
            stockSearchLoading: false,
            activeStockSearchIndex: -1,
            stockSearchVersion: 0,
            vwoImages: [],
            vwoImageCount: 0,
            status: [1, 2, 3, 4, 5, 6],
            vehicleWorkOrderFields: [
                {
                    name: this.$t('pages.module.VEHICLE_WORK_ORDER.cols.id'),
                    key: "id",
                    class: ""
                },
                {
                    name: this.$t("pages.module.VEHICLE_WORK_ORDER.cols.user"),
                    scopedSlots: {customRender: "user"},
                    class: "min-w-200px",
                },
                {
                    name: this.$t("pages.module.VEHICLE_WORK_ORDER.cols.plate"),
                    scopedSlots: {customRender: "plate"},
                },
                {
                    name: this.$t("pages.module.VEHICLE_WORK_ORDER.cols.customerCar"),
                    scopedSlots: {customRender: "car"},
                },
                {
                    name: this.$t("pages.module.VEHICLE_WORK_ORDER.cols.typeName"),
                    scopedSlots: {customRender: "typeName"},
                },
                {
                    name: this.$t("pages.module.VEHICLE_WORK_ORDER.cols.priceContainer"),
                    scopedSlots: {customRender: "price"},
                },
                {
                    name: this.$t("pages.module.VEHICLE_WORK_ORDER.cols.createdAt"),
                    scopedSlots: {customRender: "created_at"},
                },
                {
                    name: this.$t("pages.module.VEHICLE_WORK_ORDER.cols.statusId"),
                    scopedSlots: {customRender: "statusId"},
                },
                {
                    name: this.$t("common.action"),
                    key: "action",
                    scopedSlots: {customRender: "actions"}
                }
            ],
            vehicleWorkOrderItemFields: [
                {
                    name: this.$t('pages.module.VEHICLE_WORK_ORDER.save.items.cols.title'),
                    key: "title",
                    class: "",
                },
                {
                    name: this.$t('pages.module.VEHICLE_WORK_ORDER.save.items.cols.quantity'),
                    key: "quantity",
                },
                {
                    name: this.$t('pages.module.VEHICLE_WORK_ORDER.save.items.cols.price'),
                    key: "unit_price",
                    class: "",
                    show: 'record.price_type_id === 1'
                },
                {
                    name: this.$t('pages.module.VEHICLE_WORK_ORDER.save.cols.totalPrice'),
                    key: "total_price",
                    class: "",
                    show: 'record.price_type_id === 1'
                }
            ],
        }
    },
    computed: {
        itemID() {
            return this.$route.params.id;
        },
        save() {
            return this.$store.state.module.vehicle_work_order.save.data;
        },
        selectedCompany() {
            return this.$store.state.company.authorized.selectCompany
        },
        customers() {
            return this.$store.state.customer.table.data;
        },
        customerVehicle() {
            return this.$store.state.customer.vehicle.table.data;
        },
        types() {
            return this.$store.state.module.vehicle_work_order.type.table.data;
        },
        searchModels() {
            return this.$store.state.vehicle.model_search.table.data;
        },
        years() {
            return this.$store.state.vehicle.year.table.data;
        },
        vehicleWorkOrder() {
            return this.$store.state.module.vehicle_work_order.table;
        },
        vehicleWorkOrderShow() {
            return this.$store.getters['module/vehicle_work_order/showData']
        },
        vwoModuleId() {
            return getModuleIdByCode('VEHICLE_WORK_ORDER');
        },
        paymentMethods() {
            return transactionService.state.paymentMethods;
        },
        hasInitialPaymentAmount() {
            return parseFloat(this.form.data.total_paid) > 0;
        },
    },
    created() {
        this.resetFormData();
        this.resetSearch();

        if (this.itemID && !(this.itemID > 0)) {
            this.$router.push({
                path: "/module/vehicle-work-order/save",
            });
        }

        this.debouncedGetCustomer = this.debounce(this.getCustomer, 500);
        this.debouncedGetCustomerCarMagic = this.debounce(this.getCustomerCarMagic, 500);
        this.debouncedStockSearch = this.debounce(this.searchStock, 400);
    },
    mounted() {
        this._onDocumentClick = (e) => {
            if (this.activeStockSearchIndex === -1) return;
            if (e.target.closest('.vwo-stock-dropdown') || e.target.closest('.vwo-stock-input')) {
                return;
            }
            this.closeStockDropdown();
        };
        document.addEventListener('click', this._onDocumentClick);

        this.setCurrentPageBreadcrumbs(this.$t('pages.module.VEHICLE_WORK_ORDER.title'), []);

        if (this.itemID && this.itemID > 0) {
            this.loadData();
        } else {
            this.$store.dispatch('vehicle/brand/get', {
                page: {pageSize: 9999}
            })
            this.$store.dispatch('vehicle/year/get', {
                page: {pageSize: 9999},
            })
        }

        this.$store.dispatch('module/vehicle_work_order/type/get', {
            page: {pageSize: 9999}
        });

        transactionService.ensurePaymentMethods();
    },
    beforeUnmount() {
        if (this._onDocumentClick) {
            document.removeEventListener('click', this._onDocumentClick);
        }
    },
    methods: {
        formatPhonePretty,
        formatTRY(amount) {
            const n = parseFloat(amount);
            if (isNaN(n)) return '-';
            return n.toLocaleString('tr-TR', { style: 'currency', currency: 'TRY', minimumFractionDigits: 2 });
        },
        paymentMethodLabel(method) {
            if (!method) return '-';
            const key = 'common.transaction.payment.methodCode.' + method.code;
            const trans = this.$t(key);
            return trans === key ? method.name : trans;
        },
        openPaymentPanel() {
            const transactionId = this.form.data?.transaction?.id;
            if (!transactionId) return;
            transactionService.open({
                transactionId,
                onChange: () => this.loadData(),
            });
        },
        openImagePicker() {
            fileManagerPicker.open({
                uploadableType: 'MODULE_VEHICLE_WORK_ORDER',
                uploadableId: this.form.data.id,
                accept: 'image/*',
                multiple: true,
                canDelete: true,
                canDetach: true,
                onUpload: (files) => { this.loadVwoImages() },
                onAttach: null,
                onDetach: (files) => { this.loadVwoImages() },
                onDelete: (files) => { this.loadVwoImages() },
                onClose: () => { this.loadVwoImages() },
            })
        },
        loadVwoImages() {
            if (!this.form.data.id) return
            fileManagerPicker.getFiles('MODULE_VEHICLE_WORK_ORDER', this.form.data.id, {
                filter: 'image/*',
                page: 1,
                pageLimit: 50,
            }).then(result => {
                this.vwoImages = result.files
                this.vwoImageCount = result.total
            }).catch(() => {})
        },
        removeVwoImage(index) {
            const img = this.vwoImages[index]
            if (!img) return
            fileManagerPicker.detachFiles('MODULE_VEHICLE_WORK_ORDER', this.form.data.id, [img.id]).then(() => {
                this.loadVwoImages()
            }).catch(() => { /* cancelled or error */ })
        },
        debounce(fn, delay = 1000) {
            let timeout;
            return (...args) => {
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    fn.apply(this, args);
                }, delay);
            };
        },
        loadData(itemID = this.itemID) {
            this.$store.dispatch("module/vehicle_work_order/show", {
                id: itemID
            }).then(() => {
                let data = this.save;
                this.data = data;
                this.form.loading = false;
                this.form.updateStatus = true;
                this.form.data = data;
                this.form.data.company_customer.mobile_phone = data.company_customer.customer.mobile_phone;

                this.form.data.items = data.items.map(item => {
                    return {
                        ...item,
                        price: item.unit_price ?? item.total_price,
                        stock_id: item.stock_id ?? null,
                        stock_location_id: item.stock_location_id ?? null,
                        unit_id: item.unit_id ?? null,
                        _selectedStock: item.stock_id ? { id: item.stock_id, name: item.title } : null,
                        _stockSearchQuery: item.title || '',
                    }
                });

                this.tabVehicleModel = 'registeredVehicle';
                this.loadVwoImages();
            });
        },
        getSearchBrandModel(query) {
            let q = query.trim();
            if (!q.length) {
                return;
            }

            this.loadingModels = true

            this.$store.dispatch('vehicle/model_search/get', {
                filterData: {
                    q: query,
                },
                page: {pageSize: 9999}
            }).then((response) => {
                this.loadingModels = false;
            })
        },
        getCustomerCar() {
            if (!this.form.updateStatus && this.form.data.company_customer_id) {
                this.$store.dispatch('customer/vehicle/get', {
                    page: {pageSize: 10},
                    filterData: {
                        company_customer_id: this.form.data.company_customer_id,
                    }
                })
            }
        },
        getCustomerCarMagic(magic) {
            if (!this.form.updateStatus) {
                if (this.isSearchingVehicle) return;
                this.isSearchingVehicle = true;

                this.$store.dispatch('customer/vehicle/get', {
                    page: {pageSize: 10},
                    filterData: {
                        magic: magic.trim(),
                    }
                }).finally(() => {
                    this.isSearchingVehicle = false;
                });
            }
        },
        getCustomer() {
            if (this.isFetchingCustomer) return;

            const {firstname, lastname, mobile_phone} = this.form.data.company_customer;

            if (!firstname && !lastname && (!mobile_phone || mobile_phone.length < 3)) {
                return;
            }

            this.isFetchingCustomer = true;

            this.$store.dispatch('customer/get', {
                page: {pageSize: 9999},
                filterData: {firstname, lastname, mobile_phone}
            }).finally(() => {
                this.isFetchingCustomer = false;
            });
        },
        setCustomer(customer) {
            this.form.data.company_customer_id = customer.id;
            this.form.data.company_customer.firstname = customer.firstname;
            this.form.data.company_customer.lastname = customer.lastname;
            this.form.data.company_customer.mobile_phone = customer.mobile_phone;
            if (this.customerVehicle.length > 0) {
                this.tabVehicleModel = "registeredVehicle";
            }
        },
        setCustomerVehicle(vehicle) {
            this.form.data.customer_vehicle_id = vehicle.id;
            this.form.data.company_customer_id = vehicle.company_customer.id;
            this.form.data.company_customer.firstname = vehicle.company_customer.firstname;
            this.form.data.company_customer.lastname = vehicle.company_customer.lastname;
            this.form.data.company_customer.mobile_phone = vehicle.company_customer.mobile_phone;
            this.form.data.company_customer.vehicle.brand_id = vehicle.brand_id;
            this.form.data.company_customer.vehicle.model_id = vehicle.brand_model_id;
            this.form.data.company_customer.vehicle.year_id = vehicle.year_id;
            this.form.data.company_customer.vehicle.plate = vehicle.formatted_plate_number;
            this.tabVehicleModel = "registeredVehicle";
        },
        resetFormData() {
            this.form.updateStatus = false;
            this.form.data = {
                company_id: undefined,
                company_customer_id: null,
                customer_vehicle_id: null,
                type_id: null,
                status_id: 1,
                price_type_id: 1,
                odometer: 0,
                complaint: '',
                diagnosis: '',
                total_price: 0,
                total_paid: 0,
                payment_method_id: null,
                company_customer: {
                    firstname: '',
                    lastname: '',
                    mobile_phone: '',
                    vehicle: {
                        plate: "",
                        brand_id: undefined,
                        model_id: undefined,
                        year_id: undefined
                    }
                },
                customer_vehicle: {},
                items: [],
            };
        },
        resetSearch() {
            this.searchVehicle = '';
            this.form.data.customer_vehicle_id = undefined;
            this.form.data.company_customer.vehicle.plate = '';
            this.form.data.company_customer.vehicle.brand_id = undefined;
            this.form.data.company_customer.vehicle.model_id = undefined;
            this.form.data.company_customer.vehicle.year_id = undefined;
            this.form.data.company_customer_id = undefined;
            this.form.data.company_customer.firstname = '';
            this.form.data.company_customer.lastname = '';
            this.form.data.company_customer.mobile_phone = '';
            this.tabVehicleModel = "newVehicle";
        },
        calculateTotalPrice() {
            if (this.form.data.price_type_id === 1) {
                if (!Array.isArray(this.form.data.items)) {
                    this.form.data.total_price = 0
                    return
                }

                const total = this.form.data.items.reduce((sum, item) => {
                    const price = Number(item.price) || 0
                    const quantity = Number(item.quantity) || 1
                    return sum + (price * quantity)
                }, 0)

                this.form.data.total_price = Number(total.toFixed(2))
            }
        },
        cleanItemForApi(item) {
            const cleaned = {...item};
            delete cleaned._selectedStock;
            delete cleaned._stockSearchQuery;
            return cleaned;
        },
        onSubmit() {
            this.$refs.dataForm.validate((valid) => {
                if (valid) {
                    if (!this.form.updateStatus
                        && parseFloat(this.form.data.total_paid) > 0
                        && !this.form.data.payment_method_id) {
                        this.$message.error(this.$t('responseErrors.payment_method_id_required_when_paid_amount'));
                        return;
                    }

                    this.form.loading = true;

                    const cleanedItems = this.form.data.items.map(item => this.cleanItemForApi(item));

                    if (this.form.updateStatus) {
                        const updateData = cleanedItems.filter(item => item.id !== undefined);
                        const recordData = cleanedItems.filter(item => item.id === undefined);

                        if (updateData.length) {
                            this.$store.dispatch('module/vehicle_work_order/item/updateBatch', {
                                formData: {
                                    items: updateData
                                }
                            });
                        }

                        if (recordData.length) {
                            this.$store.dispatch('module/vehicle_work_order/item/addBatch', {
                                formData: {
                                    order_id: this.form.data.id,
                                    items: recordData
                                }
                            });
                        }

                        this.$store.dispatch('module/vehicle_work_order/update', {
                            id: this.form.data.id,
                            formData: {...this.form.data, items: cleanedItems}
                        }).then((response) => {
                            if (response?.status) {
                                this.onResponse(response, () => {
                                    let itemID = response.data.id;
                                    this.loadData(itemID);
                                });
                            }

                            this.form.loading = false;
                        });
                    } else {
                        this.$store.dispatch('module/vehicle_work_order/add', {
                            formData: {...this.form.data, items: cleanedItems}
                        }).then((response) => {
                            if (response?.status) {
                                this.onResponse(response, () => {
                                    let itemID = response.data.id;
                                    this.loadData(itemID);
                                    this.$router.push({
                                        path: "/module/vehicle-work-order/save/" + itemID
                                    });
                                });
                            }
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        removeItem(index, id = null) {
            if (id) {
                this.$store.dispatch("module/vehicle_work_order/item/delete", {
                    id: [id]
                }).then((successDeleted) => {
                    if (successDeleted) {
                        this.form.data.items.splice(index, 1);
                        this.calculateTotalPrice();
                    }
                });
            } else {
                this.form.data.items.splice(index, 1);
                this.calculateTotalPrice();
            }
        },
        addNewItem() {
            this.form.data.items.push({
                stock_id: null,
                stock_location_id: null,
                unit_id: null,
                title: '',
                quantity: 1,
                price: 0,
                _selectedStock: null,
                _stockSearchQuery: '',
                ...(this.form.data.id ? {order_id: this.form.data.id} : {})
            });
        },
        async searchStock(query, itemIndex) {
            if (!query || query.trim().length < 2) {
                this.stockSearchResults = [];
                this.activeStockSearchIndex = -1;
                return;
            }

            this.stockSearchVersion++;
            const version = this.stockSearchVersion;

            this.stockSearchLoading = true;
            this.activeStockSearchIndex = itemIndex;

            try {
                const selectedCompany = this.$store.state.company.authorized.selectCompany;
                const res = await this.axios.get(
                    this.sprintf(this.endpoints['company_stock_search'], [selectedCompany ?? '']),
                    {
                        params: {
                            q: query.trim(),
                            page: 1,
                            page_limit: 50,
                            ...(this.vwoModuleId ? {module_id: this.vwoModuleId} : {}),
                        }
                    }
                );

                if (version === this.stockSearchVersion) {
                    this.stockSearchResults = res.data.data || [];
                }
            } catch (e) {
                if (version === this.stockSearchVersion) {
                    this.stockSearchResults = [];
                }
            } finally {
                if (version === this.stockSearchVersion) {
                    this.stockSearchLoading = false;
                }
            }
        },
        onItemTitleInput(value, itemIndex) {
            const item = this.form.data.items[itemIndex];
            if (!item) return;

            item._stockSearchQuery = value;
            item.title = value;

            if (item._selectedStock) {
                this.clearStockSelection(itemIndex);
            }

            this.debouncedStockSearch(value, itemIndex);
        },
        selectStock(stock, itemIndex) {
            const item = this.form.data.items[itemIndex];
            if (!item) return;

            item.stock_id = stock.id;
            item.title = stock.name;
            item._selectedStock = stock;
            item._stockSearchQuery = stock.name;

            if (stock.sale_price) {
                item.price = stock.sale_price;
            }

            if (stock.unit_id) {
                item.unit_id = stock.unit_id;
            }

            if (stock.locations && stock.locations.length > 0) {
                item.stock_location_id = stock.locations[0].id;
            }

            this.closeStockDropdown();
            this.calculateTotalPrice();
        },
        clearStockSelection(itemIndex) {
            const item = this.form.data.items[itemIndex];
            if (!item) return;

            item.stock_id = null;
            item._selectedStock = null;
            item.stock_location_id = null;
        },
        closeStockDropdown() {
            this.activeStockSearchIndex = -1;
            this.stockSearchResults = [];
        },
        onItemTitleKeydown(event, itemIndex) {
            if (event.key === 'Escape') {
                this.closeStockDropdown();
            }
        },
        getStockLocationLabel(stock, locationId) {
            if (!stock || !stock.locations) return '';
            const loc = stock.locations.find(l => l.id === locationId);
            return loc ? loc.name : '';
        },
        format(price) {
            const value = Number(price)

            if (isNaN(value)) {
                return '0,00'
            }

            return value.toLocaleString('tr-TR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })
        },
        showVehicleHistory(item) {
            this.$store.dispatch('module/vehicle_work_order/get', {
                filterData: {
                    sort: 'created_at:desc',
                    customer_vehicle_id: item.id,
                },
            }).then(() => {
                this.showModal(this.$refs.vehicleWorkOrderListModal);
            });
        },
        showWorkOrderHistory(orderId) {
            this.$store.dispatch('module/vehicle_work_order/show', {
                id: orderId,
            }).then(() => {
                this.showModal(this.$refs.vehicleWorkOrderShowModal);
            });
        },
        getStatusColor(id) {
            const map = [
                "badge-light-primary",
                "badge-light-warning",
                "badge-light-success",
                "badge-light-warning",
                "badge-light-danger",
                "badge-light-danger"
            ];

            return map[id - 1] ?? "badge-light-primary";
        },
        handleMobilePhoneNumber(data) {
            this.form.data.company_customer.mobile_phone = data.number;
        },
        onCustomerFieldChange() {
            if (this.form.updateStatus) return;
            const {firstname, lastname, mobile_phone} = this.form.data.company_customer;

            if ((!firstname || firstname.length < 2) && (!lastname || lastname.length < 2) && (!mobile_phone || mobile_phone.length < 3)) {
                return;
            }

            this.debouncedGetCustomer();
        }
    },
    watch: {
        itemID(newValue, oldValue) {
            this.resetFormData();
            this.resetSearch();
        },
        searchVehicle(newValue, oldValue) {
            if (!this.form.data.company_customer_id && newValue !== oldValue && newValue.trim().length >= 3) {
                this.debouncedGetCustomerCarMagic(newValue);
            }
        },
        'form.data.company_customer.firstname': 'onCustomerFieldChange',
        'form.data.company_customer.lastname': 'onCustomerFieldChange',
        'form.data.company_customer.mobile_phone': 'onCustomerFieldChange',
        'form.data.price_type_id': {
            deep: true,
            handler(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.calculateTotalPrice()
                }
            }
        },
        'form.data.company_customer_id': {
            deep: true,
            handler(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.getCustomerCar()
                }
            }
        },
        tabVehicleModel(newValue, oldValue) {
            if (newValue !== oldValue) {
                if (newValue === "newVehicle") {
                    this.form.data.customer_vehicle_id = undefined;
                    this.form.data.company_customer.vehicle.brand_id = undefined;
                    this.form.data.company_customer.vehicle.model_id = undefined;
                    this.form.data.company_customer.vehicle.year_id = undefined;
                    this.form.data.company_customer.vehicle.plate = '';
                }
            }
        },
    }
}
</script>

<style>
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 100%;
}

.customer-card {
    padding: 14px 16px;
    border-radius: 12px;
    background-color: #ffffff;
    border: 1px dashed #e4e6ef;
    cursor: pointer;
    transition: all 0.2s ease;
}

.customer-card:hover {
    background-color: #f9f9f9;
    border-color: var(--bs-primary);
}

.customer-card.active {
    background-color: #f1faff;
    border-color: var(--bs-primary);
    box-shadow: 0 0 0 1px rgba(0, 158, 247, 0.1);
}

.customer-list {
    max-height: 300px;
    overflow-y: auto;
}

.sticky-card {
    position: sticky;
    top: 140px;
}

.modalText {
    padding: 10px;
    border-radius: 5px;
    background: #e8ebed;
}

html.dark .modalText {
    background: #090909 !important;
}

.vwo-item {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    padding-bottom: 16px;
    margin-bottom: 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.vwo-item:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
}

.vwo-item-title {
    flex: 1;
    min-width: 0;
}

.vwo-item-fields {
    display: flex;
    align-items: flex-end;
    gap: 8px;
    flex-shrink: 0;
}

.vwo-field--unit { width: 120px; }
.vwo-field--qty { width: 110px; }
.vwo-field--price { width: 120px; }
.vwo-field--action {
    display: flex;
    align-items: center;
    padding-bottom: 1px;
}

.vwo-field--action .btn.btn-icon.btn-sm {
    width: 30px;
    height: 30px;
    min-height: unset;
}

.vwo-stock-input {
    position: relative;
}

.vwo-stock-selected .el-input__wrapper {
    background-color: #f1faff !important;
    box-shadow: 0 0 0 1px #b5d8f5 inset !important;
}

.vwo-stock-selected .el-input__inner {
    font-weight: 500;
    cursor: default;
    color: var(--bs-primary, #009ef7);
}

.vwo-stock-clear {
    cursor: pointer;
    color: var(--bs-gray-500, #a1a5b7);
    display: flex;
    align-items: center;
    height: 100%;
    transition: color 0.15s;
}

.vwo-stock-clear:hover {
    color: var(--bs-danger, #f1416c);
}

.vwo-stock-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 100;
    background: var(--bs-body-bg, #fff);
    border: 1px solid var(--bs-border-color, #e4e6ef);
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    max-height: 260px;
    overflow-y: auto;
    margin-top: 4px;
    padding: 4px;
}

.vwo-stock-dropdown-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 7px 10px;
    cursor: pointer;
    border-radius: 4px;
    transition: background 0.12s;
}

.vwo-stock-dropdown-item:hover {
    background: rgba(0, 122, 255, 0.06);
}

.vwo-stock-dropdown-text {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 8px;
}

.vwo-stock-dropdown-name {
    font-size: 13px;
    font-weight: 500;
    color: var(--bs-gray-800, #3f4254);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.vwo-stock-dropdown-code {
    font-size: 11px;
    color: var(--bs-gray-500, #a1a5b7);
    flex-shrink: 0;
}

.vwo-stock-dropdown-price {
    font-size: 12px;
    font-weight: 500;
    color: var(--bs-gray-600, #7e8299);
    flex-shrink: 0;
    white-space: nowrap;
}

.vwo-stock-dropdown-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
}

.vwo-loading-spinner {
    width: 18px;
    height: 18px;
    border: 2px solid var(--bs-gray-200, #eff0f3);
    border-top-color: var(--bs-primary, #009ef7);
    border-radius: 50%;
    animation: vwo-spin 0.6s linear infinite;
}

@keyframes vwo-spin {
    to { transform: rotate(360deg); }
}

.vwo-stock-dropdown-empty {
    padding: 12px;
    text-align: center;
    color: var(--bs-gray-500, #a1a5b7);
    font-size: 13px;
}

.vwo-delete-btn {
    background: var(--bs-body-bg, #fff) !important;
    color: var(--bs-gray-500, #a1a5b7);
}

.vwo-delete-btn:hover {
    color: var(--bs-danger, #f1416c) !important;
    border-color: var(--bs-danger, #f1416c) !important;
}

.vwo-delete-label {
    display: none;
}

html.dark .vwo-item,
html.midnight .vwo-item {
    border-bottom-color: rgba(255, 255, 255, 0.06);
}

html.dark .vwo-stock-selected .el-input__wrapper,
html.midnight .vwo-stock-selected .el-input__wrapper {
    background-color: rgba(0, 158, 247, 0.08) !important;
    box-shadow: 0 0 0 1px rgba(0, 158, 247, 0.25) inset !important;
}

html.dark .vwo-stock-selected .el-input__inner,
html.midnight .vwo-stock-selected .el-input__inner {
    color: #47a8e5;
}

html.dark .vwo-stock-dropdown,
html.midnight .vwo-stock-dropdown {
    background: var(--bs-body-bg, #1e1e2d);
    border-color: var(--bs-border-color, #323248);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

html.dark .vwo-stock-dropdown-item:hover,
html.midnight .vwo-stock-dropdown-item:hover {
    background: rgba(255, 255, 255, 0.05);
}

html.dark .vwo-stock-dropdown-name,
html.midnight .vwo-stock-dropdown-name {
    color: #efefef;
}

html.cream .vwo-stock-selected .el-input__wrapper {
    background-color: #eef6ff !important;
    box-shadow: 0 0 0 1px #a8cce8 inset !important;
}

html.cream .vwo-stock-selected .el-input__inner {
    color: #0c7fd4;
}

html.cream .vwo-stock-dropdown {
    background: var(--bs-body-bg, #fffdf7);
    border-color: var(--bs-border-color, #e8e0d0);
}

html.cream .vwo-stock-dropdown-item:hover {
    background: rgba(0, 0, 0, 0.03);
}

@media (max-width: 1199px) {
    .vwo-item {
        flex-direction: column;
        align-items: stretch;
    }

    .vwo-item-fields {
        flex-wrap: nowrap;
    }

    .vwo-item-fields label {
        font-size: 11px !important;
    }

    .vwo-field--unit { flex: 1; min-width: 0; width: auto; }
    .vwo-field--qty { width: 97px; flex-shrink: 0; }
    .vwo-field--price { width: 100px; flex-shrink: 0; }

    .vwo-field--unit .el-select,
    .vwo-field--qty .el-input-number {
        width: 100% !important;
    }
}

@media (max-width: 580px) {
    .vwo-item-fields {
        flex-wrap: wrap;
    }

    .vwo-field--unit,
    .vwo-field--qty,
    .vwo-field--price,
    .vwo-field--action {
        width: calc(50% - 4px) !important;
        flex: none !important;
    }

    .vwo-field--action {
        padding-bottom: 0;
    }

    .vwo-field--action .btn.btn-icon.btn-sm.vwo-delete-btn {
        width: 100%;
        height: 32px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        padding: 0 12px !important;
        overflow: visible;
    }

    .vwo-delete-label {
        display: inline;
        font-size: 12px;
        font-weight: 500;
    }
}

.vwo-gallery-card {
    overflow: hidden;
}

.vwo-gallery-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-bottom: 1px solid var(--bs-border-color, #e4e6ef);
}

.vwo-gallery-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 600;
    color: var(--bs-gray-800, #3f4254);
}

.vwo-gallery-title svg {
    opacity: 0.5;
}

.vwo-gallery-count {
    font-size: 11px;
    font-weight: 500;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background: var(--bs-primary, #009ef7);
    color: #fff;
}

.vwo-gallery-manage {
    padding: 5px 14px;
    border-radius: 7px;
    border: none;
    background: rgba(0, 158, 247, 0.08);
    color: var(--bs-primary, #009ef7);
    font-size: 12.5px;
    font-weight: 500;
    font-family: inherit;
    cursor: pointer;
    transition: background 0.2s, color 0.2s;
    white-space: nowrap;
}

.vwo-gallery-manage:hover {
    background: rgba(0, 158, 247, 0.14);
    color: #007ad6;
}

.vwo-gallery-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 6px;
    padding: 12px;
}

.vwo-gallery-item {
    position: relative;
    aspect-ratio: 1;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    background: var(--bs-gray-100, #f5f8fa);
}

.vwo-gallery-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.2s;
}

.vwo-gallery-item:hover img {
    transform: scale(1.05);
}

.vwo-gallery-remove {
    position: absolute;
    top: 5px;
    right: 5px;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    color: #fff;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    opacity: 0;
    transform: scale(0.8);
    transition: opacity 0.15s, transform 0.15s, background 0.15s;
}

.vwo-gallery-item:hover .vwo-gallery-remove {
    opacity: 1;
    transform: scale(1);
}

.vwo-gallery-remove:hover {
    background: var(--bs-danger, #f1416c);
}

.vwo-gallery-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 24px 16px;
    cursor: pointer;
    color: var(--bs-gray-400, #b5b5c3);
    transition: color 0.15s;
}

.vwo-gallery-empty span {
    font-size: 12.5px;
}

.vwo-gallery-empty:hover {
    color: var(--bs-gray-600, #7e8299);
}

html.dark .vwo-gallery-header,
html.midnight .vwo-gallery-header {
    border-bottom-color: rgba(255, 255, 255, 0.08);
}

html.dark .vwo-gallery-title,
html.midnight .vwo-gallery-title {
    color: #cdcfda;
}

html.dark .vwo-gallery-manage,
html.midnight .vwo-gallery-manage {
    background: rgba(255, 255, 255, 0.07);
    color: rgba(255, 255, 255, 0.55);
}

html.dark .vwo-gallery-manage:hover,
html.midnight .vwo-gallery-manage:hover {
    background: rgba(255, 255, 255, 0.12);
    color: rgba(255, 255, 255, 0.85);
}

html.dark .vwo-gallery-item,
html.midnight .vwo-gallery-item {
    background: rgba(255, 255, 255, 0.05);
}

html.dark .vwo-gallery-empty,
html.midnight .vwo-gallery-empty {
    color: #6c6e82;
}

html.dark .vwo-gallery-empty:hover,
html.midnight .vwo-gallery-empty:hover {
    color: #9a9cae;
}


/* --- Initial Payment (create mode) --- */
.vwo-initial-payment {
    border: 1px solid rgba(0, 0, 0, 0.08);
    background: rgba(0, 0, 0, 0.02);
    border-radius: 10px;
    padding: 14px 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

html.dark .vwo-initial-payment,
html.midnight .vwo-initial-payment {
    border-color: rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.03);
}

.vwo-initial-payment-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.vwo-initial-payment-title {
    font-size: 13px;
    font-weight: 700;
    color: var(--panel-text-primary, #1c1c1e);
}

html.dark .vwo-initial-payment-title,
html.midnight .vwo-initial-payment-title {
    color: #EAE6E1;
}

.vwo-initial-payment-pill {
    font-size: 10px;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 999px;
    background: rgba(var(--panel-accent-rgb, 0, 122, 255), 0.1);
    color: var(--panel-accent-text, #007AFF);
    text-transform: uppercase;
    letter-spacing: 0.3px;
}

.vwo-initial-payment-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
}

.vwo-initial-payment-field {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.vwo-initial-payment-label {
    font-size: 11px;
    font-weight: 600;
    color: #8e8e93;
    text-transform: uppercase;
    letter-spacing: 0.3px;
}

html.dark .vwo-initial-payment-label,
html.midnight .vwo-initial-payment-label {
    color: #9A9CAE;
}

.vwo-initial-payment-label--required::after {
    content: ' *';
    color: #ef4444;
}

.vwo-initial-payment-hint {
    font-size: 11px;
    color: #8e8e93;
    line-height: 1.4;
}

html.dark .vwo-initial-payment-hint,
html.midnight .vwo-initial-payment-hint {
    color: #9A9CAE;
}

@media (max-width: 580px) {
    .vwo-initial-payment-grid {
        grid-template-columns: 1fr;
    }
}


/* --- Payment Summary (edit mode) --- */
.vwo-payment-summary {
    border: 1px solid rgba(0, 0, 0, 0.08);
    background: rgba(0, 0, 0, 0.02);
    border-radius: 10px;
    padding: 14px 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

html.dark .vwo-payment-summary,
html.midnight .vwo-payment-summary {
    border-color: rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.03);
}

.vwo-payment-summary-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
}

.vwo-payment-summary-title {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    font-weight: 700;
    color: var(--panel-text-primary, #1c1c1e);
}

html.dark .vwo-payment-summary-title,
html.midnight .vwo-payment-summary-title {
    color: #EAE6E1;
}

.vwo-status-pill {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 3px 9px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
}

.vwo-status-pill::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
}

.vwo-status-pill--0 { background: rgba(107, 114, 128, 0.15); color: #6b7280; }
.vwo-status-pill--1 { background: rgba(245, 158, 11, 0.15); color: #d97706; }
.vwo-status-pill--2 { background: rgba(40, 167, 69, 0.15); color: #28a745; }
.vwo-status-pill--3 { background: rgba(59, 130, 246, 0.15); color: #3b82f6; }
.vwo-status-pill--4 { background: rgba(239, 68, 68, 0.15); color: #ef4444; }

html.dark .vwo-status-pill--0,
html.midnight .vwo-status-pill--0 { color: #9CA3AF; }
html.dark .vwo-status-pill--1,
html.midnight .vwo-status-pill--1 { color: #FBBF24; }
html.dark .vwo-status-pill--2,
html.midnight .vwo-status-pill--2 { color: #34D399; }
html.dark .vwo-status-pill--3,
html.midnight .vwo-status-pill--3 { color: #60A5FA; }
html.dark .vwo-status-pill--4,
html.midnight .vwo-status-pill--4 { color: #F87171; }

.vwo-payment-summary-list {
    display: flex;
    flex-direction: column;
    gap: 1px;
    border-radius: 9px;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(0, 0, 0, 0.06);
}

html.dark .vwo-payment-summary-list,
html.midnight .vwo-payment-summary-list {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.08);
}

.vwo-payment-summary-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 14px;
    background: #fff;
}

html.dark .vwo-payment-summary-row {
    background: #15171C;
}

html.midnight .vwo-payment-summary-row {
    background: #1A1714;
}

html.cream .vwo-payment-summary-row {
    background: #FEFCF8;
}

.vwo-payment-summary-row .label {
    font-size: 12px;
    font-weight: 600;
    color: #8e8e93;
}

.vwo-payment-summary-row .value {
    font-size: 14.5px;
    font-weight: 700;
    color: var(--panel-text-primary, #1c1c1e);
    font-variant-numeric: tabular-nums;
    line-height: 1.2;
    text-align: right;
}

html.dark .vwo-payment-summary-row .label,
html.midnight .vwo-payment-summary-row .label {
    color: #9A9CAE;
}

html.dark .vwo-payment-summary-row .value,
html.midnight .vwo-payment-summary-row .value {
    color: #EAE6E1;
}

.vwo-payment-summary-row .value--paid { color: #28a745; }
.vwo-payment-summary-row .value--remaining { color: var(--panel-accent-text, #007AFF); }
html.dark .vwo-payment-summary-row .value--paid,
html.midnight .vwo-payment-summary-row .value--paid { color: #34D399; }

.vwo-payment-manage-btn {
    align-self: flex-end;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 7px 14px;
    border-radius: 8px;
    border: 1px solid var(--panel-accent, #007AFF);
    background: var(--panel-accent, #007AFF);
    color: #fff;
    font-size: 12.5px;
    font-weight: 600;
    cursor: pointer;
    transition: filter 0.15s, transform 0.05s;
    font-family: inherit;
}

.vwo-payment-manage-btn:hover {
    filter: brightness(1.08);
}

.vwo-payment-manage-btn:active {
    transform: scale(0.98);
}

@media (max-width: 580px) {
    .vwo-payment-manage-btn {
        align-self: stretch;
        justify-content: center;
    }
}
</style>